import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useGoogleLogin } from "@react-oauth/google";
import { login, logout } from "../reducers/auth";
import { useNavigate } from "react-router-dom";

const LoginButton = () => {
  const dispatch = useDispatch();
  const { authData } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const isLoggedIn = Boolean(authData);
  const [open, setOpen] = useState(false);
  const [avatarSz, setAvatarSz] = useState(32);
  const hideTimer = useRef(null);
  
  const s = {
    wrap: {
      display: "flex",
      flexDirection: "row-reverse",
      position: "relative",
    },
    login: {
      padding: "6px 14px",
      borderRadius: 20,
      background: "#6a0dad",
      color: "#fff",
      fontSize: "1.1rem",
      fontWeight: 700,
      border: "none",
      cursor: "pointer",
      transition: "background .2s",
    },
    avatar: { borderRadius: "50%", cursor: "pointer" },
    drop: {
      position: "absolute",
      right: 0,
      top: "120%",
      background: "#fff",
      border: "1px solid #d9d9d9",
      borderRadius: 10,
      minWidth: 220,
      padding: 8,
      boxShadow: "0 4px 12px rgba(0,0,0,.15)",
      zIndex: 100,
      opacity: open ? 1 : 0,
      pointerEvents: open ? "auto" : "none",
      transform: open ? "translateY(0)" : "translateY(8px)",
      transition: "all .18s ease",
    },
    hr: { height: 1, background: "#6a0dad", border: "none", margin: "0 10px" },
    emailLine: { fontSize: 13, marginBottom: 4, padding: "0 10px" },
    item: {
      width: "100%",
      textAlign: "left",
      padding: "6px 10px",
      margin: "2px 0",
      background: "transparent",
      border: "none",
      borderRadius: 6,
      fontSize: 13,
      fontWeight: 600,
      cursor: "pointer",
    },
  };

  const openMenu = () => {
    clearTimeout(hideTimer.current);
    setOpen(true);
  };
  const closeMenu = () => {
    clearTimeout(hideTimer.current);
    hideTimer.current = setTimeout(() => setOpen(false), 300); // 0.3 s grace
  };
  const googleLogin = useGoogleLogin({
    onSuccess: (codeResponse) => {
      dispatch(login({ code: codeResponse.code }));
    },
    onError: () => console.log("Login Failed"),
    flow: "auth-code",
    scope: "https://www.googleapis.com/auth/spreadsheets",
  });

  const doLogout = () => {
    setOpen(!open);
    dispatch(logout());
  };
  useEffect(() => {
    if (!isLoggedIn) return;

    const target = document.querySelector(
      "#root > header > div:nth-child(2) > nav > ul > li:nth-child(5)"
    );
    if (!target) return;

    /* initial read */
    const setSize = () =>
      setAvatarSz(Math.round(target.getBoundingClientRect().height));
    setSize();

    /* keep in sync on resize / layout shift */
    const ro = new ResizeObserver(setSize);
    ro.observe(target);
    window.addEventListener("resize", setSize);

    return () => {
      ro.disconnect();
      window.removeEventListener("resize", setSize);
    };
  }, [isLoggedIn]);

  if (!isLoggedIn)
    return (
      <div style={s.wrap}>
        <button style={s.login} onClick={() => googleLogin()}>
          Sign&nbsp;up&nbsp;/&nbsp;Log&nbsp;in
        </button>
      </div>
    );

  return (
    <div style={s.wrap} onMouseEnter={openMenu} onMouseLeave={closeMenu}>
      <img
        src={authData.avatar}
        alt="avatar"
        crossOrigin="anonymous"      // tell the browser “don’t send cookies, I just need the bytes”
  referrerPolicy="no-referrer" // prevents Google from seeing your page’s URL
        style={{ ...s.avatar, width: avatarSz, height: avatarSz }}
      />

      <div
        style={s.drop}
        onMouseEnter={openMenu} /* cancel close if re-entered */
        onMouseLeave={closeMenu}
      >
        <div style={s.emailLine}>
          <strong>{authData.email}</strong>
        </div>
        <hr style={s.hr} />

        <button
          style={s.item}
          onMouseEnter={(e) => (e.target.style.background = "#d9d9d9")}
          onMouseLeave={(e) => (e.target.style.background = "transparent")}
          onClick={() => navigate("/payment-history")}
        >
          Payment&nbsp;history
        </button>

        <button
          style={s.item}
          onMouseEnter={(e) => (e.target.style.background = "#d9d9d9")}
          onMouseLeave={(e) => (e.target.style.background = "transparent")}
          onClick={() => navigate("/help")}
        >
          Help
        </button>

        <button
          style={{ ...s.item, color: "#c62828" }}
          onMouseEnter={(e) => (e.target.style.background = "#d9d9d9")}
          onMouseLeave={(e) => (e.target.style.background = "transparent")}
          onClick={doLogout}
        >
          Log&nbsp;out
        </button>
      </div>
    </div>
  );
};

export default LoginButton;
